const formatDateTime = (date: Date) => {
  const pad = (value: number) => String(value).padStart(2, "0");
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const year = date.getFullYear();
  const hours24 = date.getHours();
  const hours12 = hours24 % 12 || 12;
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const ampm = hours24 >= 12 ? "PM" : "AM";

  return `${month}-${day}-${year} ${pad(hours12)}:${minutes}:${seconds} ${ampm}`;
};

export default formatDateTime;
